import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SsoUserDetailsDto } from '../interfaces/sso-user-details-dto';
import { SsoUserUpdateRequest } from '../interfaces/sso-user-update-request';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class UniversalIdUpdateService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/enterprise-user';
    }

    updateUniversalId(ssoUserUpdateRequest: Partial<SsoUserUpdateRequest>): Observable<SsoUserDetailsDto> {
        return this.http.put<SsoUserDetailsDto>(`${this.baseUrl}`, ssoUserUpdateRequest);
    }
}
